// extracted by mini-css-extract-plugin
export default {"checkbox":"sy8lKVWP56AlOR7ys_9A"};